import React, { useRef } from "react";
import { useEffect, useState} from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import Header from "../../components/header/header";
import CustomModal from "../../components/modal/Modal";
import InputMask from "react-input-mask";
import "./applicationsRegister.css";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faWindowClose } from "@fortawesome/free-solid-svg-icons";
import {
  getApplicationsCadastros,
  getApplicationsById,
  getApplicationUpdate,
} from "../../services/api_cadastros_aplicacoes";
import { getUnidades } from "../../services/api_unidades";
import { getTipoAplicacao } from "../../services/api_tipo_aplicacao";
import Swal from "sweetalert2";
import Spinner from "react-bootstrap/Spinner";
import { getEmpresas } from "../../services/api_base";
import { getEmpresaById } from "../../services/api_cadastros_empresas";

const ApplicationsRegister = () => {
  const location = useLocation();
  const id = location.state?.id;
  const [id_empresa, setIdEmpresa] = useState("");
  const [id_unidade, setIdUnidade] = useState("");
  const [id_tipo_aplicacao, setIdTipoAplicacao] = useState("");
  const [tag, setTag] = useState("");
  const [num_serie, setNumSerie] = useState("");
  const [num_patrimonio, setNumPatrimonio] = useState("");
  const [data_aquisicao, setDataAquisicao] = useState("");
  const [data_garantia, setDataGarantia] = useState("");
  const [marca, setMarca] = useState("");
  const [modelo, setModelo] = useState("");
  const [descricao, setDescricao] = useState("");
  const [especificacao, setEspecificacao] = useState("");
  const [empresas, setEmpresas] = useState([]);
  const [unidades, setUnidades] = useState([]);
  const [unidadesFiltradas, setUnidadesFiltradas] = useState([]);
  const [tiposAplicacao, setTiposAplicacao] = useState([]);
  const [unidadeListagem, setUnidadesListagem] = useState([]);
  const [empresasListagem, setEmpresasListagem] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [isSaving, setSaving] = useState(false)

  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({});

  const POLLING_INTERVAL = 15000;

  const inputRefs = {
    empresa: useRef(null),
    unidade: useRef(null),
    tipoAplicacao: useRef(null),
    tag: useRef(null),
    numSerie: useRef(null),
    numPatrimonio: useRef(null),
    dataAquisicao: useRef(null),
    dataGarantia: useRef(null),
    marca: useRef(null),
    modelo: useRef(null),
    descricao: useRef(null),
    especificacao: useRef(null),
  };

  useEffect(() => {
    const fetchApplication = async () => {
      try {
        const response = await getApplicationsById(id);
        const aplicacao = response.data.Aplicacao;
        if (aplicacao) {
          setIdEmpresa(aplicacao.unidade.id_empresa);
          setIdUnidade(aplicacao.id_unidade || "");
          setIdTipoAplicacao(aplicacao.id_tipo_aplicacao || "");
          setTag(aplicacao.tag || "");
          setModelo(aplicacao.modelo || "");
          setDataAquisicao(aplicacao.data_aquisicao || "");
          setDataGarantia(aplicacao.data_garantia || "");
          setNumSerie(aplicacao.num_serie || "");
          setNumPatrimonio(aplicacao.num_patrimonio || "");
          setMarca(aplicacao.marca || "");
          setDescricao(aplicacao.descricao || "");
          setEspecificacao(aplicacao.especificacao || "");
        } else {
          console.error(
            "Dados da Aplicação não encontrados na resposta:",
            response
          );
        }
      } catch (error) {
        console.error("Erro ao obter dados da unidade:", error);
      }
    };

    const fetchEmpresas = async () => {
      try {
        const response = await getEmpresas();
        if (response) {
          const empresasAtivas = response.data.empresas.filter(
            (empresa)=> empresa.deleted_at === null
          )
          setEmpresas(empresasAtivas);
        } else {
          console.error("A resposta da API não é uma array:");
        }
      } catch (error) {
        console.error("Erro ao obter empresas:", error);
      }
    };

   

    const fetchTiposAplicacao = async () => {
      try {
        const response = await getTipoAplicacao();

        if (response) {
          const tiposAplicacaoAtivos = response.data.TiposAplicacao.filter(
            (tiposDeAplicacao) => tiposDeAplicacao.deleted_at === null
          )
          setTiposAplicacao(tiposAplicacaoAtivos);
          setLoading(false);
        } else {
          console.error("A resposta da API não é uma array:");
        }
      } catch (error) {
        console.error("Erro ao obter empresas:", error);
      }
    };

    if (id) {
      fetchApplication();
    }

    fetchEmpresas();
    fetchTiposAplicacao();
    const interval = setInterval(()=>{
      fetchTiposAplicacao()
    }, POLLING_INTERVAL);
    return () => clearInterval(interval);
  }, [id]);

  const handleUnidadesEmpresa = async (idEmpresa) => {
    Swal.fire({
      title: "Carregando unidades da empresa",
      didOpen: async () => {
        Swal.showLoading();
        try {
          const response = await getEmpresaById(idEmpresa);
          if (response.status === 200) {
            const unidadesAtivas = response.data.empresa.unidades.filter(
              (unidade) => unidade.deleted_at == null
            );
            setUnidadesListagem(unidadesAtivas);
            console.log(unidadesAtivas, response)
            Swal.close();
          }
        } catch (error) {
          console.log(error);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenModal = (title, body) => {
    setModalContent({ title, body });
    setShowModal(true);
  };

  const validarInputs = () => {
    if (!descricao|| !tag || !id_unidade || !id_tipo_aplicacao || !empresas) {
      Swal.fire({
        icon: "warning",
        title: "Oops!",
        text: "O preenchimento dos campos: 'Descrição, Empresa, Tag, Tipo de Aplicação e Unidade', é obrigatório.",
      });
      return false;
    }
    return true;
  };

  const addCadastro = async (body) => {
    try {
      const response = await getApplicationsCadastros(body);

      if (response && response.status === 200) {
        regret();
      } else {
        console.error("Erro ao cadastrar aplicação:", response);
      }
    } catch (error) {
      console.error("Erro ao cadastrar empresa:", error);
    } finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };

  const newUpdate = async (body) => {
    try {
      const response = await getApplicationUpdate(id, body);

      if (response && response.status === 200) {
        regret();
      } else {
        console.error("Erro ao atualizar registro:", response);
      }
    } catch (error) {
      if (error.response && error.response.status === 422) {
        handleOpenModal(
          "Erro de validação",
          "Houve um erro na validação dos dados."
        );
      } else if (error.response && error.response.status === 500) {
        handleOpenModal(
          "Erro interno do servidor",
          "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde."
        );
      } else {
        console.error("Erro ao atualizar a empresa:", error);
        handleOpenModal(
          "Erro ao atualizar a empresa",
          "Por favor, tente novamente mais tarde."
        ); // Exibir mensagem genérica de erro
      }
    } finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };

  const handleSalvar = () => {
    if (validarInputs()) {
      setSaving(true)
      let body = {
        id_unidade,
        id_tipo_aplicacao,
        tag,
        num_serie,
        num_patrimonio,
        data_aquisicao,
        data_garantia,
        marca,
        descricao,
        especificacao,
      };

      if (id) {
        newUpdate(body);
      } else {
        addCadastro(body);
      }
    }
  };

  const handleTag = (e) => {
    const value = e.target.value;
    if (value.length <= 8) {
      setTag(value);
    } else {
      Swal.fire({
        icon: "info",
        title: "O campo Tag não pode ultrapassar 8 caracteres",
      });
    }
  };

  const handleModelo = (e) => {
    const value = e.target.value;
    if (value.length <= 30) {
      setModelo(value);
    } else {
      Swal.fire({
        icon: "info",
        title: "O campo Tag não pode ultrapassar 8 caracteres",
      });
    }
  };

  const handleDescricao = (e) => {
    const value = e.target.value;
    if (value.length <= 30) {
      setDescricao(value);
    } else {
      Swal.fire({
        icon: "info",
        title: "O campo Descrição não pode ultrapassar 30 caracteres",
      });
    }
  };

  const handleMarca = (e) => {
    const value = e.target.value;
    if (value.length <= 15) {
      setMarca(value);
    } else {
      Swal.fire({
        icon: "info",
        title: "O campo Marca não pode ultrapassar 15 caracteres",
      });
    }
  };

  const handleEspecificacao = (e) => {
    const value = e.target.value;
    if (value.length <= 100) {
      setEspecificacao(value);
    } else {
      Swal.fire({
        icon: "info",
        title: "O campo Especificação não pode ultrapassar 100 caracteres",
      });
    }
  };

  const handleNumPatrimonio = (e) => {
    const value = e.target.value;
    if (value.length <= 20) {
      setNumPatrimonio(value);
    } else {
      Swal.fire({
        icon: "info",
        title:
          "O campo Número de Patrimônio não pode ultrapassar 20 caracteres",
      });
    }
  };

  const handleNumSerie = (e) => {
    const value = e.target.value;
    if (value.length <= 20) {
      setNumSerie(value);
    } else {
      Swal.fire({
        icon: "info",
        title: "O campo Número de Série não pode ultrapassar 20 caracteres",
      });
    }
  };


  const handleKeyDown = (e, nextFieldRef) => {
    if (e.key === 'Enter' && nextFieldRef.current) {
      e.preventDefault();
      const elementToFocus = nextFieldRef.current.inputRef || nextFieldRef.current;
  
      if (typeof elementToFocus.focus === 'function') {
        elementToFocus.focus();
      } else {
        console.warn('O elemento de input não tem o método focus.');
      }
    }
  };
  
  

  const regret = () => {
    window.history.back();
  };

  return (
    <>
      <Header title="Cadastros / Cadastro de Aplicações" />
      <div className="content-wrapper pl-5 pr-5 pt-2">
        {isLoading ? (
          <div className="center-btn">
            <h5 className="mb-5">Carregando dados</h5>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <Form className="mt-4">
            <Row>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formEmpresa">
                  <Form.Label>Empresa</Form.Label>
                  <Form.Control
                    as="select"
                    value={id_empresa}
                    onChange={(e) => {
                      setIdEmpresa(e.target.value);
                      handleUnidadesEmpresa(e.target.value);
                    }}
                    ref={inputRefs.empresa}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.unidade)}
                    required
                  >
                    <option value="">Selecione</option>
                    {empresas &&
                      empresas.map((empresa) => (
                        <option key={empresa.id} value={empresa.id}>
                          {empresa.nome}
                        </option>
                      ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formUnidade">
                  <Form.Label>Unidade</Form.Label>
                  <Form.Control
                    as="select"
                    value={id_unidade}
                    disabled={!id_empresa ? true : false}
                    onChange={(e) => setIdUnidade(e.target.value)}
                    ref={inputRefs.unidade}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.tipoAplicacao)}
                    required
                  >
                    <option value="">Selecione</option>
                    {unidadeListagem &&
                      unidadeListagem.map((unidade, index) => (
                        <option
                          key={index}
                          value={unidade.id}
                          data-nome={unidade.nome}
                        >
                          {unidade.nome}
                        </option>
                      ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formTipoAplicacao">
                  <Form.Label>Tipo de Aplicação</Form.Label>
                  <Form.Control
                    as="select"
                    value={id_tipo_aplicacao}
                    onChange={(e) => setIdTipoAplicacao(e.target.value)}
                    ref={inputRefs.tipoAplicacao}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.tag)}
                  >
                    <option value="">Selecione</option>
                    {tiposAplicacao &&
                      tiposAplicacao.map((TiposAplicacao) => (
                        <option
                          key={TiposAplicacao.id}
                          value={TiposAplicacao.id}
                        >
                          {TiposAplicacao.descricao}
                        </option>
                      ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6} className="mb-3">
                <Form.Group controlId="formTag">
                  <Form.Label>Tag</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Digite a tag"
                    value={tag}
                    onChange={handleTag}
                    ref={inputRefs.tag}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.numSerie)}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group controlId="formNumSerie">
                  <Form.Label>Número de Série</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Digite o número de série"
                    value={num_serie}
                    onChange={handleNumSerie}
                    ref={inputRefs.numSerie}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.numPatrimonio)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formNumPatrimonio">
                  <Form.Label>Número de Patrimônio</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Digite o número de patrimônio"
                    value={num_patrimonio}
                    onChange={handleNumPatrimonio}
                    ref={inputRefs.numPatrimonio} // Se usar uma biblioteca, isso pode ser necessário
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.dataAquisicao)}
                  />
                </Form.Group>
              </Col>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formDataAquisicao">
                  <Form.Label>Data de Aquisição</Form.Label>
                  <InputMask
                    type="date"
                    placeholder="dd/mm/aaaa"
                    value={data_aquisicao}
                    onChange={(e) => setDataAquisicao(e.target.value)}
                    className="form-control"
                  />
                </Form.Group>
              </Col>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formDataGarantia">
                  <Form.Label>Data de Garantia</Form.Label>
                  <InputMask
                    type="date"
                    placeholder="dd/mm/aaaa"
                    value={data_garantia}
                    onChange={(e) => setDataGarantia(e.target.value)}
                    className="form-control"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formMarca">
                  <Form.Label>Marca</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Digite a marca"
                    value={marca}
                    onChange={handleMarca}
                    ref={inputRefs.marca}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.modelo)}
                  />
                </Form.Group>
              </Col>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formModelo">
                  <Form.Label>Modelo</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Digite a modelo"
                    value={modelo}
                    onChange={handleModelo}
                    ref={inputRefs.modelo}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.descricao)}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="formDescricao">
                  <Form.Label>Descrição</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Digite a descrição"
                    value={descricao}
                    onChange={handleDescricao}
                    ref={inputRefs.descricao}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.especificacao)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={12} className="mb-3">
                <Form.Group controlId="formEspecificao">
                  <Form.Label>Especificação:</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Insira mais informações sobre a aplicação"
                    value={especificacao}
                    ref={inputRefs.especificacao}
                    onChange={handleEspecificacao}
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="center-two-btn d-flex justify-content-center ">
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={handleSalvar}
                disabled = {isSaving}
              >
                {isSaving ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  <FontAwesomeIcon icon={faSave} />
                )}
              </Button>
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={regret}
              >
                <FontAwesomeIcon icon={faWindowClose} />
              </Button>
            </div>
          </Form>
        )}
      </div>

      <CustomModal
        show={showModal}
        handleClose={handleCloseModal}
        title={modalContent.title}
        body={modalContent.body}
      />
    </>
  );
};

export default ApplicationsRegister;

